module.exports = __webpack_public_path__ + "img/brand7.6aecae1f.png";